module.exports = __webpack_public_path__ + "static/media/star.41e81f2a.svg";